<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="goBack()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder toevoegen</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<div v-if="device">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>3</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 3 - Koppelen</v-list-tile-title>
						<v-list-tile-sub-title>Koppel je E-finder aan je telefoon</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-container class="item-group">
				<p>We gebruiken een pincode om je E-finder te valideren. Deze sturen we je per sms.</p>
				<p>Geef de code op die op je E-finder staat:</p>

				<form @submit.prevent="updateCode()">
					<v-text-field
						v-model="code"
						label="Code"
						placeholder="XXXXXX"
						:counter="6"
						:maxlength="6"
						:error-messages="errorMessage"
						:loading="state == 'loading'"
						@input="errorMessage = ''"
						required
						large
						class="mt-5 mb-4"
					></v-text-field>

					<v-btn type="submit" block dark depressed large color="primary" :loading="state == 'loading'">Wijzigen</v-btn>
				</form>

			</v-container>
			</div>
		</v-content>
	</div>
</template>

<script>
  export default {
    computed: {
      device() {
        return this.$store.getters.device;
      },
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '')
            .toUpperCase();
        });
      }
    },
    data() {
      return {
        code: '',
        state: 'idle',
        updatingCode: false,
        errorMessage: '',
      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('toggleMainMenu');
      },
      goBack() {
        this.$router.go(-1);
      },
      async updateCode() {
        if(this.code === this.device.id_for_humans)
          return this.next(this.device.id);

        this.state = 'loading';

        try {
          const response = await this.$http.post(`/account/devices/${this.device.id}/updateCode`,
			{code: this.code},
			{ headers: { Authorization: `Bearer ${this.$store.state.auth.token}` } }
		  );

		  const selectedDevice = await this.$store.dispatch('switchDevice', response.data.id);
          await this.$store.dispatch('loadDevices');

          this.state = 'idle';
          this.next(selectedDevice.id);

        } catch (error) {
          this.errorMessage = error.response.data.errors.code[0];
          return this.state = 'invalid';
        }

      },
      next(id) {
        this.$router.push({ name: 'devices.activate', params: { id }});
      },
    },
    created() {
      this.$store.dispatch('selectDevice', this.$route.params.id)
        .then((d) => {
          this.code = d.id_for_humans;
        });
    },
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
